"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PentacodeAPIClient = void 0;
const openapi_1 = require("@pentacode/openapi");
const api_1 = require("./api");
class PentacodeAPIClient extends openapi_1.OpenAPIClient {
    constructor(baseUrl, authToken) {
        super(api_1.RestApi, baseUrl);
        this.authToken = authToken;
    }
    async _performRequest(method, url, body, headers) {
        if (this.authToken) {
            headers.set("Authorization", `Bearer ${this.authToken}`);
        }
        return await super._performRequest(method, url, body, headers);
    }
}
exports.PentacodeAPIClient = PentacodeAPIClient;
//# sourceMappingURL=client.js.map